import React, { useState, useEffect } from "react";
import {
  Card,
  Button,
  ButtonGroup,
  Frame,
  Modal,
  Link,
  TextContainer,
} from "@shopify/polaris";
import { withRouter, useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import * as authService from "../services/authService";
import { STATUS_CHANGE } from "../Component/Dashboard/index";
import userData from "../staticenv";
import preview from "./Images/preview.png";
import $ from "jquery";
export const PATHNAME = "PATHNAME";
function MainPage() {
  // const [pathname, setPathName] = useState("");
  const history = useHistory();
  const dispatch = useDispatch();

  const [loadingOrderLink, setLoadingOrderLink] = useState(false);
  const [modalOrderLink, setModalOrderLink] = useState(false);
  const status_change = useSelector((state) => state.allReducer.status_change);

  function setRoute(pathname) {
    history.push(pathname);
  }

  useEffect(() => {
    // setTimeout(() => {
    //     window.location.href = "javascript:$zopim.livechat.window.show();";
    //     window.location.href = "javascript:$zopim.livechat.window.toggle()";
    // }, 2000);

    authService
      .statusChange_load()
      .then((response) => {
        dispatch({
          type: STATUS_CHANGE,
          data: { ...response, loading: false },
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  function callFunction() {
    window.Beacon("open");
    // window.location.href = "javascript:$zopim.livechat.window.show();";
    // window.location.href = "javascript:$zopim.livechat.window.toggle();";
  }

  const handlePreviewPage = () => {
    // setRoute("/preview");
    // window.location.href = "javascript:$zopim.livechat.window.toggle();";
    setLoadingOrderLink(true);
    authService
      .previewOrderLink()
      .then((response) => {
        setLoadingOrderLink(false);
        if (response && response.data && response.data.data) {
          window.open(response.data.data, "_blank");
        } else {
          setModalOrderLink(true);
        }
      })
      .catch((error) => {
        setLoadingOrderLink(false);
        console.log(error);
      });
  };
  const handleDeleteClose = () => {
    setModalOrderLink(false);
  };
  return (
    <Card>
      <div
        style={{
          justifyContent: "space-between",
          display: "flex",
          padding: "10px",
        }}
      >
        <ButtonGroup>
          <Button
            onClick={() => {
              setRoute("/");
            }}
            outline
          >
            Dashboard
          </Button>
          <Button
            onClick={() => {
              setRoute("/appearance");
            }}
            outline
          >
            Appearance
          </Button>
          {/* <Button
                        onClick={() => {
                            setRoute("/staticts");
                            // window.location.href = "javascript:$zopim.livechat.window.show();";
                            // window.location.href =
                            //     "javascript:$zopim.livechat.window.toggle();";
                        }}
                        outline
                    >
                        Analytics
                    </Button> */}

          {/* <Button
                        onClick={() => {
                            setRoute("/account");
                            // window.location.href = "javascript:$zopim.livechat.window.show();";
                            // window.location.href =
                            //     "javascript:$zopim.livechat.window.toggle();";
                        }}
                        outline
                    >
                        Account
                    </Button> */}

          {/* <Button
            onClick={() => {
              setRoute("/faqs");
              window.location.href =
                "javascript:$zopim.livechat.window.hide();";
            }}
            outline
          >
            FAQs
          </Button> */}
        </ButtonGroup>
        <span className="btn-color" >
          <Button onClick={() => callFunction()} primary>
            Support
          </Button>
          {/* <Button
                        loading={loadingOrderLink}
                        monochrome={!loadingOrderLink}
                        onClick={() => {
                            status_change && status_change.status
                                ? handlePreviewPage()
                                : setModalOrderLink(true);
                        }}
                        primary
                    >
                        Preview
                    </Button> */}
        </span>
      </div>
      <Modal
        open={modalOrderLink}
        onClose={handleDeleteClose}
        title="Preview Activation Message"
        secondaryActions={[
          {
            content: "Close",
            onAction: handleDeleteClose,
          },
        ]}
      >
        <Modal.Section>
          {status_change && status_change.status ? (
            <TextContainer>
              <p>
                To preview your activation message go to one of your{" "}
                <Link
                  onClick={() => {
                    window.open(`https://${userData.shop}/admin/orders`);
                  }}
                >
                  {" "}
                  recent orders
                </Link>
                , and select 'More Actions' located at the top right, and from
                the dropdown choose 'View order status page'.
              </p>
              <br />
              <img style={{ width: "180px" }} src={preview}></img>
              <br />

              <p>
                Make sure you choose an order from a customer that has yet to
                create an account, as the message does not show for already
                created accounts.
              </p>
              {/* <p>
                                For perview to work, there should be a new order
                                in last 48 hours in your store with
                                non-registered customer
                            </p> */}
            </TextContainer>
          ) : (
            <TextContainer>
              <p>Please enable the app first. </p>
            </TextContainer>
          )}
        </Modal.Section>
      </Modal>
    </Card>
  );
}
export default withRouter(MainPage);
